import { lazy } from 'react';
export const GiveKudosLauncherLazy = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "@atlaskit-internal_lazy-give-kudos" */
'./main'));